import React from 'react';

import PropTypes from 'prop-types';
import { faMagnifyingGlass } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

const SearchBar = ({ onChange, value, className = '', disabled = false }) => {
  const iconStyles = cn(
    'absolute h-4 w-4 left-2.5 top-1/2 -translate-y-1/2',
    disabled ? 'text-muted-foreground' : ''
  );

  return (
    <div className="relative">
      <Input
        aria-label="Search"
        className={cn('pl-8', className)}
        disabled={disabled}
        id="search"
        name="search"
        onChange={onChange}
        placeholder="Search..."
        type="text"
        value={value}
      />

      <FontAwesomeIcon className={iconStyles} icon={faMagnifyingGlass} />
    </div>
  );
};

SearchBar.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default SearchBar;
